import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import MultiListSearch from '../../search/MultiListSearch';

export default props => {
  const inputProps = {
    filterBy: 'itemId',
  };

  return <FormInputTagsItem {...props} inputComponent={MultiListSearch} inputProps={inputProps} />;
};
